<template>
    <div class="space-y-10">
        <div v-for="group in groups" :key="group.key">
            <div class="flex items-center gap-3 mb-5">
                <DayPill :group="group" />
            </div>

            <SessionTimeline :items="group.items" :event-location="eventLocation" :event-title="eventTitle" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { AgendaGroup } from './agenda';
import DayPill from './DayPill.vue';
import SessionTimeline from './SessionTimeline.vue';

defineProps<{
    groups: AgendaGroup[];
    eventLocation?: string | null;
    eventTitle?: string;
}>();
</script>
